import { computed, h } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { BLOCK_PREFIX, CLICK_EVENT } from './utils/constants';
import { addPxUnit } from './utils/format';

var props = {
  /**
   * 图片名称或图片链接
   */
  name: propTypes.string(),
  /**
   * 图标颜色
   */
  color: propTypes.string(),
  /**
   * 图标大小，如 20px 2em，默认单位为 px
   */
  size: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  /**
   * HTML 标签
   */
  tag: propTypes.string().def('i'),
  /**
   * 自定义 icon 类名前缀，用于自定义图标
   */
  classPrefix: propTypes.string().def("".concat(BLOCK_PREFIX, "-icon")),
  /**
   * 自定义 icon 字体基础类名
   */
  fontClassName: propTypes.string().def("".concat(BLOCK_PREFIX, "-icon"))
};
var emits = [CLICK_EVENT];

var _createComponent = createComponent('icon'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var isImage = computed(function () {
      return props.name && props.name.includes('/');
    });
    var classes = computed(function () {
      return isImage.value ? "".concat(className, "__img") : "".concat(props.classPrefix, "-").concat(props.name, " ").concat(props.fontClassName);
    });
    var style = computed(function () {
      return isImage.value ? {
        width: addPxUnit(props.size),
        height: addPxUnit(props.size)
      } : {
        color: props.color,
        fontSize: addPxUnit(props.size)
      };
    });
    function onClick(e) {
      emit(CLICK_EVENT, e);
    }
    return function () {
      var renderTag = isImage.value ? 'img' : props.tag;
      return h(renderTag, {
        "class": classes.value,
        style: style.value,
        src: isImage.value ? props.name : undefined,
        onClick: onClick
      }, slots["default"] && slots["default"]());
    };
  }
});

script.__file = "components/src/component/icon/icon.vue";

/*
 * @Description: Icon 组件导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-02-17 20:28:20
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:03:09
 */
var _Icon = script;

export { _Icon as default };
